export default from './inlineArrayTransformer';
